import {Component, DoCheck, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ExgEventArgs} from '../../../misc/classes/ExgEventArgs';
import {ExcTranslation} from 'exc-core-v2';
import {NestedTreeControl} from '@angular/cdk/tree';
import {EnumerationService} from '../../../services/enumeration.service';
import {ExgApplicationTab} from 'exc-tab-v2';
import {CalculationVersionComponent} from '../../../Calculation/calculation-version/calculation-version.component';
import {ApplicationService} from '../../../services/application.service';
import {ExgModalService} from 'exc-controls-v2';
import {ExcRestService} from 'exc-rest-v2';
import {SelectionChange} from '@angular/cdk/collections';
import {ExcSecurityService} from 'exc-security-v2';

export interface Doc { qverID?: string; pdID?: string; cvID?: string; [key: string]: any; }
export interface Folder { source: string; documents?: Doc[];  [key: string]: any; }
type Node = Folder | Doc;
@Component({
  selector: 'app-tab-report-details',
  templateUrl: './tab-report-details.component.html',
  styles: [
  ]
})
export class TabReportDetailsComponent extends ExcTranslation implements OnInit, DoCheck {
  @Input()
  entityID: any;
  @Input()
  SummaryQuestionnaireTable: Doc[] = [] as Doc[];
  @Input()
  SummaryCalculationTable: Doc[] = [] as Doc[];
  @Input()
  SummaryPhotoDocumentationTable: Doc[] = [] as Doc[];
  @Input()
  Events: ExgEventArgs | any;
  @Input() ReportFolderStates: string[] = [];
  @Output() reportFolderStatesChange = new EventEmitter<string[]>();

  folders: Folder[] = [] as Folder[];

  config = {
    hasChild: (_: number, node: any): boolean => {
      return !!node.documents;
    },
    treeControl: new NestedTreeControl<any>(node => node.documents ?? []),


    openQuestionnaire: (node: any): void => {
      const data = { qcnfID: node.qver_qcfgID, qverID: node.qverID, isTest: false, qverName: node.qverName};
      this.appSvc.QuestionnaireVersion.OpenTab(data);
    },

    openExistingPhotoDoc: (pd: any): void => {
      pd = Object.assign(pd, {FKID: pd.pd_FKID});

      this.appSvc.Task.PhotoDocumentation.OpenTab(
        pd,
        {Events: this.Events}
      );
    },

    openPhotoDocEditTextModal: (event: any, isUpload: boolean = false, editModel: any = {}): void => {
      event.stopPropagation();

      this.modal.show('ModalFinishPhotoDocComponent', { isUpload, editModel }).subscribe( (rslt: any) => {
        if ( rslt ) {
          const url = this.excRest.computeUrl('PhotoDocumentationU', {pdID: editModel.pdID});
          const uiModel: any = {
            pdName: rslt.pdName,
            pdUPT: editModel.pdUPT,
            pdDescription: rslt.pdDescription,
            pdPhotoDocumentationStatus_enmIdent: rslt.pdPhotoDocumentationStatus_enmIdent
          };
          this.excRest.put(url, uiModel).subscribe((res: any) => {
            if (res?.success) {
              this.modal.showToast(
                'Datenänderung erfolgreich!'
                , 'md-toast', 'fas fa-check');
              this.Events?.Document?.UpdateDialog?.Closed?.emit();
            }
            else {
              this.modal.showToast('Datenänderung fehlgeschlagen!', 'md-toast', 'fas fa-exclamation');
            }
          });
        }
      });
    },

    deletePhotoDoc: (event: any, deleteModel: any = {}): void => {
      event.stopPropagation();

      this.modal.showSimple( 'Bilddokumentation löschen'
        , 'Möchten Sie diese Bilddokumentation wirklich löschen?'
        , true, true, 'Ja, löschen', 'Abbrechen')
        .subscribe((response: any) => {
          if (response && deleteModel.pdID) {
            const url = this.excRest.computeUrl('PhotoDocumentationD', {pdID: deleteModel.pdID});
            this.excRest.delete(url, {pdUPT: deleteModel.pdUPT}).subscribe((res: any) => {
              if (res?.success) {
                this.modal.showToast(
                  'Datenlöschung erfolgreich!'
                  , 'md-toast', 'fas fa-check');
                this.Events?.Document?.UpdateDialog?.Closed?.emit();
              } else {
                this.modal.showToast('Datenlöschung fehlgeschlagen!', 'md-toast', 'fas fa-exclamation');
              }
            });
          }
        });
    },

    createNewCalculationVersion: (row: any): void => {
      const data = {
        cv_ctID: row.ctID,
        cv_fkID: row.cv_FKID,
        sourceID: this.entityID
      };
      if (row.cvID) {
        Object.assign(data, {cvID: row.cvID});
      }

      const tab = new ExgApplicationTab(
        row.cvName ?? row.ctName,
        CalculationVersionComponent,
        data,
        row.cvID
      );
      tab.Open();
    },

    openModalCalculationVersion: (event: any, row: any): void => {
      event.stopPropagation();

      Object.assign(row, {hideDelete: true});

      this.modal.show('ModalCalculationVersionComponent', row)
        .subscribe((retValue: any) => {
          if (retValue) {
            this.excRest.put(
              this.excRest.computeUrl(
                'CalculationVersionU', {
                  cvID: row.cvID
                }
              ), retValue).subscribe((response: any) => {
              if (response?.success) {
                this.modal
                  .showToast('Kalkulation geändert', 'md-toast bg-green', 'far fa-check');
                this.Events?.Document?.UpdateDialog?.Closed?.emit();
              }
            });
          }
        });
    },

    deleteCalculationVersion: (event: any, row: any): void => {
      event.stopPropagation();

      this.modal.showSimple( 'Kalkulation löschen'
        , 'Möchten Sie diese Kalkulation wirklich löschen?'
        , true, true, 'Ja, löschen', 'Abbrechen')
        .subscribe((response: any) => {
          if (response) {
            this.excRest.delete(
              this.excRest.computeUrl(
                'CalculationVersionD', {
                  cvID: row.cvID
                }
              ), {
                cvID: row.cvID,
                cvUPT: row.cvUPT,
              }).subscribe((rtValue: any) => {
              if (rtValue?.success) {
                this.modal
                  .showToast('Kalkulation gelöscht', 'md-toast bg-green', 'far fa-check');
                this.Events?.Document?.UpdateDialog?.Closed?.emit();
              }
            });
          }
        });
    },


    openQuestionnaireVersion: (event: any, qverElement: any): void =>  {
      event.stopPropagation();

      this.modal.show('ModalQuestionnaireVersionComponent', { ...qverElement, isEdit: true})
        .subscribe((retValue: any) => {
          if (retValue) {
            this.Events?.Document?.UpdateDialog?.Closed?.emit();
          }
        });
    },

    exportQuestionnaireReportExcel: (event: any, row: any): void => {
      event.stopPropagation();

      this.appSvc.QuestionnaireVersion.ExportExcelReport(row.qverID);
    },

    exportQuestionnaireReportPDF: (event: any, row: any): void => {
      event.stopPropagation();

      this.appSvc.QuestionnaireVersion.ExportPDFReport(row.qverID);
    },

    deleteQuestionnaireVersion: (event: any, row: any): void => {
      event.stopPropagation();

      this.modal.showSimple( 'Fragebogen löschen'
        , 'Möchten Sie diese Fragebogen wirklich löschen?'
        , true, true, 'Ja, löschen', 'Abbrechen')
        .subscribe((response: any) => {
          if (response) {
            this.excRest.delete(this.excRest.computeUrl('QuestionnaireVersionD', {
              qverID: row.qverID
            }), {
              qverID: row.qverID, qverUPT: row.qverUPT,
            }).subscribe((rtValue: any) => {
              if (rtValue?.success) {
                this.modal
                  .showToast('Fragebogen gelöscht', 'md-toast bg-green', 'far fa-check');
                this.Events?.Document?.UpdateDialog?.Closed?.emit();
              }
            });
          }
        });
    },
  };
  isEmpty = false;

  constructor(
    public enumSvc: EnumerationService,
    private appSvc: ApplicationService,
    private modal: ExgModalService,
    private excRest: ExcRestService,
    public excSecurity: ExcSecurityService
  ) {
    super();
  }

  /** Map zum schnellen Restore: source -> Ordner-Node */
  private folderBySource = new Map<string, any>();
  private reportDataState = '';
  private reportRefreshScheduled = false;
  private isRestoringFolders = false;

  ngOnInit(): void {
    this.config.treeControl.expansionModel.changed.subscribe(
      (change: SelectionChange<any>) => {
        if (this.isRestoringFolders) {
          return;
        }

        for (const added of change.added || []) {
          if (
            added?.documents?.length &&
            !this.ReportFolderStates.includes(added.source)
          ) {
            this.ReportFolderStates.push(added.source);
          }
        }

        for (const removed of change.removed || []) {
          const index =
            this.ReportFolderStates.indexOf(removed.source);

          if (index !== -1) {
            this.ReportFolderStates.splice(index, 1);
          }
        }
      }
    );

    this.rebuildFolders();
    this.reportDataState = this.getReportDataState();
  }

  ngDoCheck(): void {
    const currentState = this.getReportDataState();

    if (currentState === this.reportDataState) {
      return;
    }

    this.reportDataState = currentState;

    if (this.reportRefreshScheduled) {
      return;
    }

    this.reportRefreshScheduled = true;

    setTimeout(() => {
      this.reportRefreshScheduled = false;
      this.rebuildFolders();
    });
  }

  private getReportDataState(): string {
    return JSON.stringify({
      questionnaires: (this.SummaryQuestionnaireTable || [])
        .map(item => [
          item.qverID,
          item.qverUPT,
          item.qverName
        ]),

      calculations: (this.SummaryCalculationTable || [])
        .map(item => [
          item.cvID,
          item.cvUPT,
          item.cvName
        ]),

      photoDocumentations:
        (this.SummaryPhotoDocumentationTable || [])
          .map(item => [
            item.pdID,
            item.pdUPT,
            item.pdName,
            item.pdDescription,
            item.pdPhotoDocumentationStatus_enmIdent
          ])
    });
  }

  private rebuildFolders(): void {
    const expandedSources = [
      ...(this.ReportFolderStates || [])
    ];

    const questionnaireDocuments =
      this.SummaryQuestionnaireTable || [];

    const calculationDocuments =
      this.SummaryCalculationTable || [];

    const photoDocumentationDocuments =
      this.SummaryPhotoDocumentationTable || [];

    this.folders = [
      {
        source: 'Questionnaire',
        dokFolderCount: questionnaireDocuments.length,
        documents: questionnaireDocuments
      },
      {
        source: 'Calculation',
        dokFolderCount: calculationDocuments.length,
        documents: calculationDocuments
      },
      {
        source: 'PhotoDocumentation',
        dokFolderCount: photoDocumentationDocuments.length,
        documents: photoDocumentationDocuments
      }
    ];

    this.isEmpty =
      questionnaireDocuments.length === 0 &&
      calculationDocuments.length === 0 &&
      photoDocumentationDocuments.length === 0;

    this.folderBySource.clear();

    for (const folder of this.folders) {
      if (folder?.documents?.length) {
        this.folderBySource.set(
          folder.source,
          folder
        );
      }
    }

    const foldersToExpand = expandedSources
      .map(source => this.folderBySource.get(source))
      .filter(Boolean);

    this.isRestoringFolders = true;

    this.config.treeControl.expansionModel.clear();
    this.config.treeControl.expansionModel.select(
      ...foldersToExpand
    );

    this.isRestoringFolders = false;
  }

  openEntity(node: any): void {
    if (node.cvID) {
      this.config.createNewCalculationVersion(node);
    } else if (node.pdID) {
      this.config.openExistingPhotoDoc(node);
    } else if (node.qverID) {
      this.config.openQuestionnaire(node);
    }
  }
}
